import React, { Component } from 'react';

class VideoRenderer extends Component {
    // static proptypes = {
    //     children: PropTypes.func.isRequired
    // }

    state = {
        mediaData: null
    }

    componentDidMount() {
        this.updateDataFromProps(this.props)
    }

    componentWillReceiveProps(props) {
        this.updateDataFromProps(props)
    }

    updateDataFromProps = (props) => {

        if (!props)
            return

        const { data = null } = props;

        this.setState({ mediaData: data });
    }

    render() {
        const { mediaData = null } = this.state;

        const { playOnStart = true, showControls = false } = this.props;

        if (!mediaData) {
            return null;
        }

        const { FileID = -1, UploadFile = "", autoplay = true, loop = true, muted = true, scale = "fit" } = mediaData;

        return (
            <div style={{ width: '100%', height: '100%' }}>
                <video type="video/mp4" key={"media" + FileID} ref={this.videoRef} id={FileID} autoPlay={autoplay && playOnStart} controls={showControls} loop={loop} muted={muted} style={{ width: '100%', height: '100%', objectFit: scale }}>
                    <source src={UploadFile} codecs="avc1.4D401E, mp4a.40.2" />
                </video>
            </div>
        )
    }
}

export default VideoRenderer